import axios from "axios";
import {
  CategoriesAndIndustriesResponse,
  FetchTemplatesRequest,
  FetchTemplatesResponse,
} from "src/types/experiences/templates";

const cleverstoryApiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;

export const experiencesTemplatesApi = {
  getTemplates: async (
    page: number,
    limit: number,
    body: FetchTemplatesRequest,
  ): Promise<FetchTemplatesResponse> => {
    const response = await axios.post(
      `${cleverstoryApiUrl}/api/2.0/templates?page=${page}&limit=${limit}`,
      body,
    );
    return response.data;
  },

  getCategoriesAndIndustries:
    async (): Promise<CategoriesAndIndustriesResponse> => {
      const response = await axios.get(
        `${cleverstoryApiUrl}/api/2.0/templates/categories-industries`,
      );
      return response.data;
    },

  updateTemplateVisibility: async (params: {
    template: string;
    enabled: boolean;
  }): Promise<void> => {
    await axios.put(`${cleverstoryApiUrl}/api/2.0/templates/visibility`, params);
  },
};
